import React from 'react'
import { CustomFloatingFilterDisplayProps } from 'ag-grid-react'
import CtxBudgetDriverCheckboxGroup from '../../../../../features/budgetDrivers/components/CtxBudgetDriverCheckboxGroup'

/**
 * Custom floating filter component for budget driver selection using checkbox group
 */
const BudgetDriverColumnFilter: React.FC<CustomFloatingFilterDisplayProps> = ({ model, onModelChange }) => {
  const selectedDrivers = model?.values || []

  const handleChange = (driverIds: number[]) => {
    if (driverIds.length === 0) {
      onModelChange(null)
    } else {
      onModelChange({
        filterType: 'set',
        values: driverIds
      })
    }
  }

  return (
    <div style={{ width: 400, padding: '4px' }}>
      <CtxBudgetDriverCheckboxGroup value={selectedDrivers} onChange={handleChange} checkOnSearch />
    </div>
  )
}

export default BudgetDriverColumnFilter
